import { Box, Stack, Grid, Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import Image from './Image';
import { resize_image } from '@utils/image';
import { useRouter } from 'next/router';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

interface Props {
  isFullFooter: boolean;
}

const Footer: FunctionComponent<Props> = ({ isFullFooter }) => {
  const theme = useTheme();
  const router = useRouter();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  console.log(isMobile);
  return (
    <Grid py={isFullFooter ? undefined : 8} container spacing={5} justifyContent="center">
      <Grid item xs={12} sm={12} md={5}>
        <Stack alignItems={isFullFooter ? undefined : 'center'}>
          <Image
            alt="potioneer-logo"
            src={resize_image({
              url: 'https://images.potioneer.com/images-landing/PTN_LOGO_ICON-01_D4f3S4Td9.png',
              width: 45,
              height: 45,
            })}
            sx={{ height: '45px', width: '45px' }}
          />
          {isFullFooter && isMobile ? (
            <Box mt={4}>
              <Typography align={isFullFooter ? undefined : 'center'} fontSize="14px">
                We empower chefs to express food inspiration without compromising their value.
              </Typography>
            </Box>
          ) : (
            <Box mt={4}>
              <Typography align={isFullFooter ? undefined : 'center'} fontSize="14px">
                We empower chefs to express food
              </Typography>
              <Typography align={isFullFooter ? undefined : 'center'} fontSize="14px">
                inspiration without compromising their
              </Typography>
              <Typography align={isFullFooter ? undefined : 'center'} fontSize="14px">
                value.
              </Typography>
            </Box>
          )}
          {!isMobile && (
            <>
              <Stack direction="row" mt={5} spacing={3}>
                <img
                  alt="twitter logo"
                  src="https://images.potioneer.com/Icon_MinimalsCC/SVG/Social_media-TW_vPShSoCfo.svg"
                  onClick={() => {
                    window.open(`https://twitter.com/Potioneer`, '_blank');
                  }}
                  style={{ cursor: 'pointer' }}
                />
                <img
                  alt="facebook logo"
                  src="https://images.potioneer.com/Icon_MinimalsCC/SVG/Social_media-FB_oXWucJ_r6.svg"
                  onClick={() => {
                    window.open(`https://www.facebook.com/PotioneerTH`, '_blank');
                  }}
                  style={{ cursor: 'pointer' }}
                />
                <img
                  alt="ig logo"
                  src="https://images.potioneer.com/Icon_MinimalsCC/SVG/Social_media-IG_rVbDvlPlF.svg"
                  onClick={() => {
                    window.open(`https://www.instagram.com/potioneerth/`, '_blank');
                  }}
                  style={{ cursor: 'pointer' }}
                />
              </Stack>
              <Typography mt={10} mb={5} fontSize="14px">
                © 2021. All rights reserved
              </Typography>
            </>
          )}
        </Stack>
      </Grid>
      {isFullFooter && (
        <>
          <Grid item xs={12} sm={3} md={2}>
            <Stack spacing={3}>
              <Typography variant="overline">Potioneer</Typography>
              <Typography
                fontSize="14px"
                sx={{ cursor: 'pointer' }}
                onClick={() => router.push('/how-it-work')}
              >
                About us
              </Typography>
              <Typography
                fontSize="14px"
                sx={{ cursor: 'pointer' }}
                onClick={() => window.open('mailto:info@potioneer.com')}
              >
                Contact us
              </Typography>
              {/* <Typography fontSize="14px" sx={{ cursor: 'pointer' }} onClick={() => router.push('/')}>
              FAQ
            </Typography> */}
            </Stack>
          </Grid>
          <Grid item xs={12} sm={3} md={2}>
            <Stack spacing={3}>
              <Typography variant="overline">Legal</Typography>
              <Typography
                fontSize="14px"
                sx={{ cursor: 'pointer' }}
                onClick={() => router.push('/terms-and-conditions?section=terms-and-conditions')}
              >
                Terms and Condition
              </Typography>
              <Typography
                fontSize="14px"
                sx={{ cursor: 'pointer' }}
                onClick={() => router.push('/terms-and-conditions?section=privacy-policy')}
              >
                Privacy Policy
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <Stack spacing={3}>
              <Typography variant="overline">Contact</Typography>
              <Typography
                fontSize="14px"
                sx={{
                  // textDecoration: 'underline',
                  cursor: 'pointer',
                }}
                onClick={() => window.open('mailto:info@potioneer.com')}
              >
                info@potioneer.com
              </Typography>
              <Box>
                <Typography variant="subtitle1" fontSize="16px">
                  Potioneer House
                </Typography>
                <Typography fontSize="14px">Sukumvit 24 Rd. Khlong Tan</Typography>
                <Typography fontSize="14px">Khlong Toei, Bangkok</Typography>
                <Typography fontSize="14px">Thailand 10110</Typography>
              </Box>
            </Stack>
          </Grid>
        </>
      )}
      {isMobile && (
        <Grid item xs={12} sm={3}>
          <Stack direction="row" justifyContent="center" alignItems="center" spacing={3}>
            <img
              alt="twitter logo"
              src="https://images.potioneer.com/Icon_MinimalsCC/SVG/Social_media-TW_vPShSoCfo.svg"
              onClick={() => {
                window.open(`https://twitter.com/Potioneer`, '_blank');
              }}
              style={{ cursor: 'pointer' }}
            />
            <img
              alt="facebook logo"
              src="https://images.potioneer.com/Icon_MinimalsCC/SVG/Social_media-FB_oXWucJ_r6.svg"
              onClick={() => {
                window.open(`https://www.facebook.com/PotioneerTH`, '_blank');
              }}
              style={{ cursor: 'pointer' }}
            />
            <img
              alt="ig logo"
              src="https://images.potioneer.com/Icon_MinimalsCC/SVG/Social_media-IG_rVbDvlPlF.svg"
              onClick={() => {
                window.open(`https://www.instagram.com/potioneerth/`, '_blank');
              }}
              style={{ cursor: 'pointer' }}
            />
          </Stack>
          {isFullFooter && (
            <Stack justifyContent="center" alignItems="center">
              <Typography mt={5} mb={3} fontSize="14px">
                © 2021. All rights reserved
              </Typography>
            </Stack>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default Footer;
